import styled, { css } from 'styled-components';
import { Typography } from 'antd';
const { Text } = Typography;

const sizeStyles = {
  small: css`
    font-size: 12px;
  `,
  medium: css`
    font-size: 16px;
  `,
  large: css`
    font-size: 20px;
  `,
};

const weightStyles = {
  regular: css`
    font-weight: 400;
  `,
  bold: css`
    font-weight: 700;
  `,
};

export const HSText = styled(Text)`
  font-family: Euclid Circular A;
  color: ${(props) => props.color || '#000'};
  ${(props) => sizeStyles[props.size || 'medium']}
  ${(props) => weightStyles[props.weight || 'regular']}  
  &.highlight {
    background-color: yellow;
  }
  &.title-blue {
    color: #005d98;
    font-size: 18px;
    font-weight: 700;
  }
  &.blue-small {
    color: #005d98;
    font-size: 16px;
  }
  &.blue-big {
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 51px;
    color: #005d98;
  }
  &.form-title {
    color: #113e57;
    font-size: 16px;
    font-weight: 700;
  }
  &.body {
    color: #113e57;
  }
  &.card-today-title {
    font-family: 'Euclid Circular A';
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    color: #113e57;
  }
  &.card-today-value {
    font-family: 'Euclid Circular A';
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: #808080;
  }
  &.grey-small {
    font-family: 'Euclid Circular A';
    font-weight: 400;
    font-size: 14px;
    color: #808080;
    line-height: 100%;
  }
  &.grey-value {
    height: 18px;
    font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #6087a0;
  }
  &.power-value {
    font-size: 22px;
    color: #005d98;
    &.unit {
      font-size: 16px;
      position: relative;
    }
  }
  &.sensor-state-title {
    font-size: 18px;
    line-height: 100%;
    &.open {
      color: #005d98;
    }
    &.closed,
    &.on {
      color: #005d98;
    }
  }
  &.tab-title {
    font-family: 'Euclid Circular A';
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #808080;
  }
  &.no-events {
    font-family: 'Euclid Circular A';
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #606060;
  }
`;
